module.exports = __webpack_public_path__ + "img/合歡山.21a3b68b.jpg";